/* ------------------------------------------------------------------ */
/*  Somara Labs theme — vanilla JS replacing the old React contexts.   */
/*  Handles: theme toggle, mobile menu, header scroll, cart + search   */
/*  drawers (Shopify AJAX Cart + Section Rendering API).               */
/* ------------------------------------------------------------------ */
(function () {
  "use strict";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* -------------------- Header scroll behaviour ----------------- */
  const header = $("[data-site-header]");
  const pill = $("[data-nav-pill]");
  function onScroll() {
    if (!header) return;
    const scrolled = window.scrollY > 24;
    // Swap between the two translate classes so only one is ever applied
    // (both set the same Tailwind translate var) — this hides the marquee on scroll.
    header.classList.toggle("-translate-y-10", scrolled);
    header.classList.toggle("translate-y-0", !scrolled);
    // At the top the pill is transparent over the near-black hero, so the
    // brand-red nav colour drops to ~2.9:1. header-top flips it to white.
    header.classList.toggle("header-top", !scrolled);
    if (pill) {
      pill.classList.toggle("border-[var(--color-border-soft)]", scrolled);
      pill.classList.toggle("bg-[var(--color-surface-soft)]", scrolled);
      pill.classList.toggle("shadow-[0_12px_42px_var(--color-card-shadow)]", scrolled);
      pill.classList.toggle("backdrop-blur-2xl", scrolled);
      pill.classList.toggle("border-transparent", !scrolled);
      pill.classList.toggle("bg-transparent", !scrolled);
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* -------------------- Mobile menu ----------------------------- */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-mobile-toggle]")) {
      const menu = $("[data-mobile-menu]");
      if (menu) menu.classList.toggle("hidden");
    }
  });

  /* -------------------- Generic drawer open/close --------------- */
  function openDrawer(root, panel, scrim) {
    if (!root) return;
    root.classList.remove("pointer-events-none");
    root.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      if (scrim) scrim.classList.replace("opacity-0", "opacity-100");
      if (panel) {
        panel.classList.remove("translate-x-full", "-translate-y-full");
      }
    });
    document.body.style.overflow = "hidden";
  }
  function closeDrawer(root, panel, scrim, hiddenClass) {
    if (!root) return;
    if (scrim) scrim.classList.replace("opacity-100", "opacity-0");
    if (panel) panel.classList.add(hiddenClass);
    root.setAttribute("aria-hidden", "true");
    setTimeout(() => root.classList.add("pointer-events-none"), 300);
    document.body.style.overflow = "";
  }

  /* -------------------- Cart drawer ----------------------------- */
  const cartRoot = $("[data-cart-root]");
  const cartPanel = $("[data-cart-panel]");
  const cartScrim = $("[data-cart-scrim]");

  function openCart() { openDrawer(cartRoot, cartPanel, cartScrim); }
  function closeCart() { closeDrawer(cartRoot, cartPanel, cartScrim, "translate-x-full"); }

  /* Paint the drawer from already-fetched section HTML. */
  function applyCartSection(html) {
    try {
      if (!html) return;
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const newBody = $("[data-cart-body]", tmp);
      const newFooter = $("[data-cart-footer]", tmp);
      if (newBody) $("[data-cart-body]").innerHTML = newBody.innerHTML;
      if (newFooter) {
        const footer = $("[data-cart-footer]");
        footer.innerHTML = newFooter.innerHTML;
        footer.className = newFooter.className;
      }
    } catch (e) { /* fall back to a hard navigation if needed */ }
  }

  // Update the header bag counter from the cart JSON.
  async function refreshCartCount() {
    try {
      const cart = await (await fetch("/cart.js")).json();
      const badge = $("[data-cart-count]");
      if (badge) {
        badge.textContent = cart.item_count;
        badge.classList.toggle("hidden", cart.item_count === 0);
      }
    } catch (e) {}
  }

  /* Used by quantity changes, which have no section payload of their own. */
  async function refreshCart() {
    const [sectionHtml] = await Promise.all([
      fetch(`${window.location.pathname}?sections=cart-drawer`, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then((r) => r.json()).then((d) => d["cart-drawer"]).catch(() => null),
      refreshCartCount(),
    ]);
    applyCartSection(sectionHtml);
  }

  function showCartError(form, msg) {
    if (!form) { return; }
    let el = form.querySelector("[data-cart-error]");
    if (!el) {
      el = document.createElement("p");
      el.setAttribute("data-cart-error", "");
      el.className = "mt-3 text-sm text-[var(--color-brand-danger)]";
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  async function cartAdd(id, quantity, form) {
    if (!id) { showCartError(form, "Please choose an option first."); return; }
    if (form) showCartError(form, "");
    try {
      /* Ask for the drawer markup in the same response. Three sequential
         round trips - add, then the section, then the count - was the whole
         of the delay; this makes it one plus a parallel count. */
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: id, quantity: quantity || 1, sections: "cart-drawer" }),
      });
      if (!res.ok) {
        let msg = "Sorry, this item can't be added right now.";
        try { const data = await res.json(); if (data && data.description) msg = data.description; } catch (e) {}
        showCartError(form, msg);
        return;
      }
      let added = null;
      try { added = await res.json(); } catch (e) {}
      const html = added && added.sections && added.sections["cart-drawer"];
      if (html) {
        applyCartSection(html);
        openCart();
        refreshCartCount();               /* badge can land a moment later */
      } else {
        await refreshCart();              /* older response shape */
        openCart();
      }
    } catch (err) {
      showCartError(form, "Network error — please try again.");
    }
  }

  async function cartChange(line, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    await refreshCart();
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openCart(); return; }
    if (e.target.closest("[data-close-cart]") || e.target.closest("[data-cart-scrim]")) { closeCart(); return; }

    const plus = e.target.closest("[data-cart-plus]");
    const minus = e.target.closest("[data-cart-minus]");
    const remove = e.target.closest("[data-cart-remove]");
    if (plus || minus || remove) {
      const el = plus || minus || remove;
      const line = parseInt(el.getAttribute("data-line"), 10);
      const li = el.closest("[data-line-item]");
      const qtyEl = li ? $("span.min-w-4", li) : null;
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      let next = current;
      if (plus) next = current + 1;
      if (minus) next = current - 1;
      if (remove) next = 0;
      cartChange(line, next);
    }
  });

  // Intercept any product add-to-cart form so it uses the drawer instead of reloading.
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("form[action*='/cart/add']");
    if (!form) return;

    // Buy now works by setting return_to, so Shopify adds the item and then
    // redirects to checkout. Intercepting that post swallows the redirect and
    // opens the drawer instead, which made Buy now behave exactly like Add to
    // cart. When return_to is set, stay out of the way and let the browser
    // submit natively.
    const returnTo = form.querySelector("[name='return_to']");
    if (returnTo && returnTo.value) return;

    e.preventDefault();
    const idField = form.querySelector("[name='id']");
    const qtyField = form.querySelector("[name='quantity']");
    if (!idField) return;

    // Brief "Adding…" feedback on the button that was actually pressed. Taking
    // the first submit in the form put the label on Add to cart no matter which
    // button the visitor clicked.
    const btn = e.submitter || form.querySelector("[type='submit']");
    let original;
    if (btn) { original = btn.textContent; btn.textContent = "Adding…"; btn.disabled = true; }

    Promise.resolve(cartAdd(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1, form))
      .finally(() => { if (btn) { btn.textContent = original; btn.disabled = false; } });
  });

  /* -------------------- Search drawer --------------------------- */
  const searchRoot = $("[data-search-root]");
  const searchPanel = $("[data-search-panel]");
  const searchScrim = $("[data-search-scrim]");
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-search]")) {
      e.preventDefault();
      openDrawer(searchRoot, searchPanel, searchScrim);
      setTimeout(() => { const i = $("[data-search-input]"); if (i) i.focus(); }, 320);
      return;
    }
    if (e.target.closest("[data-close-search]") || e.target.closest("[data-search-scrim]")) {
      closeDrawer(searchRoot, searchPanel, searchScrim, "-translate-y-full");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      closeDrawer(searchRoot, searchPanel, searchScrim, "-translate-y-full");
    }
  });

  /* -------------------- Product card colours -------------------- */
  /* Picking a colour retargets the card's add-to-cart form at that variant, and
     swaps the image if the variant has its own. */
  document.addEventListener("click", (e) => {
    const swatch = e.target.closest("[data-card-color]");
    if (!swatch) return;
    const card = swatch.closest("[data-product-card]");
    if (!card) return;

    $$("[data-card-color]", card).forEach((b) => {
      b.setAttribute("aria-checked", String(b === swatch));
    });

    const label = $("[data-card-color-label]", card);
    if (label) label.textContent = swatch.getAttribute("data-card-color") || "";

    const input = $("[data-card-variant-input]", card);
    const id = swatch.getAttribute("data-variant-id");
    if (input && id) input.value = id;

    const img = $("[data-card-image]", card);
    const src = swatch.getAttribute("data-variant-image");
    if (img && src) img.src = src;

    const form = $("[data-card-form]", card);
    const btn = form && form.querySelector("button[type='submit']");
    if (btn) {
      const sold = swatch.getAttribute("data-available") === "false";
      btn.disabled = sold;
      btn.classList.toggle("opacity-50", sold);
      btn.classList.toggle("cursor-not-allowed", sold);
      btn.textContent = sold ? "Sold out" : btn.textContent;
    }
  });

  function initCardColors() {
    $$("[data-product-card]").forEach((card) => {
      const checked = $('[data-card-color][aria-checked="true"]', card);
      const label = $("[data-card-color-label]", card);
      if (checked && label) label.textContent = checked.getAttribute("data-card-color") || "";
    });
  }

  /* -------------------- How-to card animations ------------------ */
  /* The loop itself is the native autoplay attribute on a muted, playsinline
     video, so it runs with nothing here executing at all. This function only
     ever takes motion away, and only from someone whose system asks for
     reduced motion — they get the poster frame, which is the illustration
     fully drawn. Written this way round on purpose: if this file fails to
     load, the animations still play, which is the requested behaviour. */
  function initCardAnims() {
    const vids = $$("[data-card-anim]");
    if (!vids.length) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      vids.forEach((v) => { v.autoplay = false; v.pause(); v.currentTime = 0; });
      return;
    }
    /* Belt and braces. These cards start inside a .reveal, which is opacity 0
       until it scrolls into view, and Chrome declines to autoplay a video it
       considers invisible. It normally starts one once it becomes visible, but
       nudging it when the reveal lands costs nothing and removes the doubt.
       play() on an already-playing video resolves without doing anything. */
    const nudge = () => vids.forEach((v) => {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    });
    vids.forEach((v) => {
      const card = v.closest(".reveal");
      if (card) card.addEventListener("transitionend", nudge, { once: true });
    });
    setTimeout(nudge, 1200);
  }

  /* -------------------- Collection filters ---------------------- */
  /* Filters the cards already rendered on the page — no reload, no dependency
     on storefront filters being configured. Only covers the current page of
     results, which is why the section paginates high by default. */
  function initCollectionFilters() {
    const root = $("[data-collection-root]");
    if (!root) return;
    const grid = $("[data-collection-grid]", root);
    if (!grid) return;

    const search = $("[data-collection-search]", root);
    const price = $("[data-collection-price]", root);
    const priceLabel = $("[data-collection-price-label]", root);
    const count = $("[data-collection-count]", root);
    const empty = $("[data-collection-empty]", root);
    const reset = $("[data-collection-reset]", root);
    const cards = $$("[data-product-card]", grid);

    /* Mirror the money format already rendered server-side, so the slider label
       matches the prices on the cards instead of inventing its own. */
    const template = priceLabel ? priceLabel.textContent.trim() : "";
    const formatMoney = (cents) => {
      const amount = (cents / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return template ? template.replace(/[\d.,]+/, amount) : amount;
    };

    const apply = () => {
      const term = (search && search.value || "").trim().toLowerCase();
      const max = price ? Number(price.value) : Infinity;
      let shown = 0;

      cards.forEach((card) => {
        const haystack = card.getAttribute("data-search") || "";
        const cardPrice = Number(card.getAttribute("data-price"));
        const matches = (!term || haystack.indexOf(term) !== -1) && (!price || cardPrice <= max);
        card.hidden = !matches;
        if (matches) shown++;
      });

      if (priceLabel && price) priceLabel.textContent = formatMoney(Number(price.value));
      if (count) count.textContent = shown + (shown === 1 ? " product" : " products");
      if (empty) empty.classList.toggle("hidden", shown !== 0);
      grid.classList.toggle("hidden", shown === 0);
    };

    if (search) search.addEventListener("input", apply);
    if (price) price.addEventListener("input", apply);
    if (reset) reset.addEventListener("click", () => {
      if (search) search.value = "";
      if (price) price.value = price.max;
      apply();
    });

    apply();
  }

  /* -------------------- Images are not draggable ---------------- */
  /* CSS user-drag covers Chrome and Safari but not Firefox, and neither
     reaches an image added after load. One delegated listener does both. */
  document.addEventListener("dragstart", (e) => {
    if (e.target && e.target.closest && e.target.closest("img, picture, svg, video")) {
      e.preventDefault();
    }
  });

  /* -------------------- Panel spotlight ------------------------- */
  /* Every panel is rendered server-side; switching just toggles which one is
     shown, so there is no fetch and all three stay crawlable. Colour swatches
     rewrite the CTA links so the chosen variant carries to the product page. */
  function panelSelectColor(swatch) {
    const group = swatch.parentElement;
    const view = swatch.closest("[data-panel-view]");
    if (!group || !view) return;
    $$("[data-panel-color]", group).forEach((b) => {
      b.setAttribute("aria-checked", String(b === swatch));
    });
    const label = $("[data-panel-color-label]", view);
    if (label) label.textContent = swatch.getAttribute("data-panel-color") || "";

    /* The swatch only ever rewrote the label and the CTA links, so picking a
       colour left the photograph on whichever variant loaded first. */
    const shot = $("[data-panel-shot]", view);
    const shotSrc = swatch.getAttribute("data-panel-image");
    if (shot && shotSrc) shot.src = shotSrc;

    const variantId = swatch.getAttribute("data-variant-id");
    $$("[data-panel-cta]", view).forEach((a) => {
      const base = a.getAttribute("data-panel-cta");
      a.setAttribute("href", variantId ? base + "?variant=" + variantId : base);
    });
  }

  function panelSelectTab(tab) {
    const root = tab.closest("[data-panel-spotlight]");
    if (!root) return;
    const id = tab.getAttribute("data-panel-tab");
    $$("[data-panel-tab]", root).forEach((t) => {
      const on = t === tab;
      t.setAttribute("aria-selected", String(on));
      t.setAttribute("tabindex", on ? "0" : "-1");
    });
    $$("[data-panel-view]", root).forEach((v) => {
      v.hidden = v.getAttribute("data-panel-view") !== id;
    });
  }

  document.addEventListener("click", (e) => {
    const tab = e.target.closest("[data-panel-tab]");
    if (tab) { panelSelectTab(tab); return; }
    const swatch = e.target.closest("[data-panel-color]");
    if (swatch) panelSelectColor(swatch);
  });

  /* Arrow-key navigation between tabs, per the tablist pattern. */
  document.addEventListener("keydown", (e) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    const tab = e.target.closest("[data-panel-tab]");
    if (!tab) return;
    const root = tab.closest("[data-panel-spotlight]");
    if (!root) return;
    const tabs = $$("[data-panel-tab]", root);
    const next = tabs[(tabs.indexOf(tab) + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length];
    if (!next) return;
    e.preventDefault();
    panelSelectTab(next);
    next.focus();
  });

  function initPanelSpotlight() {
    /* Seed the colour label and CTA links from whichever swatch starts checked. */
    $$("[data-panel-view]").forEach((view) => {
      const checked = $('[data-panel-color][aria-checked="true"]', view);
      if (checked) panelSelectColor(checked);
    });
  }

  /* -------------------- FAQ accordion --------------------------- */
  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("[data-faq-toggle]");
    if (!toggle) return;
    const item = toggle.parentElement;
    const panel = $("[data-faq-panel]", item);
    const icon = $("[data-faq-icon]", toggle);
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    // Close siblings (single-open accordion, matching the original default).
    const root = toggle.closest("[data-faq]");
    if (root) {
      $$("[data-faq-toggle]", root).forEach((t) => {
        if (t === toggle) return;
        t.setAttribute("aria-expanded", "false");
        const p = $("[data-faq-panel]", t.parentElement);
        const ic = $("[data-faq-icon]", t);
        if (p) { p.classList.remove("grid-rows-[1fr]", "pt-4", "opacity-100"); p.classList.add("grid-rows-[0fr]", "opacity-0"); }
        if (ic) ic.classList.remove("rotate-45");
      });
    }
    toggle.setAttribute("aria-expanded", String(!isOpen));
    if (panel) {
      panel.classList.toggle("grid-rows-[1fr]", !isOpen);
      panel.classList.toggle("pt-4", !isOpen);
      panel.classList.toggle("opacity-100", !isOpen);
      panel.classList.toggle("grid-rows-[0fr]", isOpen);
      panel.classList.toggle("opacity-0", isOpen);
    }
    if (icon) icon.classList.toggle("rotate-45", !isOpen);
  });

  /* -------------------- Carousels (auto-slide + prev/next) ------ */
  function initCarousels() {
    const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    $$("[data-carousel]").forEach((car) => {
      const track = $("[data-carousel-track]", car);
      if (!track) return;

      const step = () => {
        const first = track.querySelector(":scope > *");
        const w = first ? first.getBoundingClientRect().width : 320;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "24") || 24;
        return w + gap;
      };
      const prev = $("[data-carousel-prev]", car);
      const next = $("[data-carousel-next]", car);
      if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));

      // Gentle infinite auto-slide. Recycle the first slide to the end as it
      // scrolls out, so the loop never ends and never jumps.
      const auto = car.getAttribute("data-carousel-auto") !== "false";
      const designMode = window.Shopify && window.Shopify.designMode;
      if (!auto || reduced || designMode) return;
      if (track.children.length < 2) return;

      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "24") || 24;
      const speed = parseFloat(car.getAttribute("data-carousel-speed")) || 0.5; // px per frame ≈ 30px/s
      track.style.overflowAnchor = "none";
      let paused = false;
      // Accumulate the scroll position as a float — scrollLeft rounds to an
      // integer, so sub-pixel increments must be tracked separately.
      let pos = track.scrollLeft;
      const resume = () => { paused = false; pos = track.scrollLeft; };
      car.addEventListener("mouseenter", () => { paused = true; });
      car.addEventListener("mouseleave", resume);
      car.addEventListener("focusin", () => { paused = true; });
      car.addEventListener("focusout", resume);
      track.addEventListener("touchstart", () => { paused = true; }, { passive: true });
      track.addEventListener("touchend", () => { setTimeout(resume, 2500); }, { passive: true });

      function tick() {
        if (!paused && track.scrollWidth > track.clientWidth + 4) {
          pos += speed;
          const first = track.firstElementChild;
          if (first) {
            const firstW = first.getBoundingClientRect().width + gap;
            if (pos >= firstW) {
              track.appendChild(first);
              pos -= firstW;
            }
          }
          track.scrollLeft = pos;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* -------------------- Custom cursor (dot + trailing ring) ----- */
  function initCursor() {
    const dot = $("[data-cursor-dot]");
    const ring = $("[data-cursor-ring]");
    if (!dot || !ring) return;
    // Skip on touch / coarse pointers — nothing to follow.
    if (window.matchMedia && window.matchMedia("(hover: none), (pointer: coarse)").matches) return;

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let dx = mx, dy = my, rx = mx, ry = my;
    let ds = 1, rs = 1;
    let hovering = false, visible = false;

    window.addEventListener("mousemove", (e) => {
      mx = e.clientX; my = e.clientY;
      visible = true;
    }, { passive: true });

    window.addEventListener("mouseover", (e) => {
      const t = e.target;
      hovering = !!(t && t.closest && (t.closest("a") || t.closest("button") || t.closest("[role='button']") || t.closest("label[for]")));
    }, { passive: true });

    document.addEventListener("mouseleave", () => { visible = false; });

    const lerp = (a, b, n) => a + (b - a) * n;
    function frame() {
      // Dot tracks tightly; ring trails more slowly (mirrors the spring feel).
      dx = lerp(dx, mx, 0.35); dy = lerp(dy, my, 0.35);
      rx = lerp(rx, mx, 0.18); ry = lerp(ry, my, 0.18);
      ds = lerp(ds, hovering ? 2.5 : 1, 0.2);
      rs = lerp(rs, hovering ? 1.5 : 1, 0.2);
      dot.style.transform = "translate(" + dx + "px," + dy + "px) translate(-50%,-50%) scale(" + ds + ")";
      ring.style.transform = "translate(" + rx + "px," + ry + "px) translate(-50%,-50%) scale(" + rs + ")";
      dot.style.opacity = visible ? "1" : "0";
      ring.style.opacity = visible ? "0.3" : "0";
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* -------------------- Scroll reveal (IntersectionObserver) ---- */
  function initReveal() {
    const els = $$(".reveal");
    if (!("IntersectionObserver" in window) || els.length === 0) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "-80px", threshold: 0.05 });
    els.forEach((el) => io.observe(el));
  }

  /* -------------------- Hero video (desktop / mobile) ---------- */
  /* The inline script in sections/home.liquid sets the initial source during
     parse. This only handles switching when the breakpoint is crossed — a
     resize or a phone rotating — so a landscape desktop clip never ends up
     cropped on a portrait screen (or vice versa). */
  function initHeroVideo() {
    const v = $("[data-hero-video]");
    if (!v) return;
    const desktop = v.getAttribute("data-video-desktop");
    const mobile = v.getAttribute("data-video-mobile");
    if (!desktop || !mobile || desktop === mobile) return;

    const mq = window.matchMedia("(max-width: 767px)");
    const apply = () => {
      const next = mq.matches ? mobile : desktop;
      const poster = v.getAttribute(mq.matches ? "data-poster-mobile" : "data-poster-desktop");
      if (poster) v.poster = poster;
      /* the inline script attaches the first source after window load; until then only the poster switches */
      if (!v.getAttribute("src")) return;
      if (v.getAttribute("src") === next) return;
      v.setAttribute("src", next);
      v.load();
      v.play().catch(() => {});
    };
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else mq.addListener(apply);
  }

  /* -------------------- Scroll progress bar -------------------- */
  function initScrollProgress() {
    const bar = $(".scroll-progress");
    if (!bar) return;
    const update = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight || 1);
      bar.style.transform = `scaleX(${Math.min(1, Math.max(0, scrolled))})`;
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  if (document.readyState !== "loading") { initReveal(); initScrollProgress(); initHeroVideo(); initCursor(); initCarousels(); initPanelSpotlight(); initCardColors(); initCardAnims(); initCollectionFilters(); }
  else document.addEventListener("DOMContentLoaded", () => { initReveal(); initScrollProgress(); initHeroVideo(); initCursor(); initCarousels(); initPanelSpotlight(); initCardColors(); initCardAnims(); initCollectionFilters(); });
})();
